PLAYER p1 20 You
PLAYER p2 20 Practice partner
ACTIVE p1
p1 battlefield Island | copies=2
p1 hand Anticipate
p1 library Grizzly Bears
p1 library Lightning Bolt
p1 library Island
p1 library Forest | copies=20
p2 library Forest | copies=20
